import actionTypes from './actionTypes';
import update from 'immutability-helper';
import { extractError } from 'src/utils/error';
export const initialState = {
  program: {},
  currentModule: {},
  fundraiser: {},
  isSubscribed: false,
  uncompletedSections: [],
};

export default function (state = initialState, action) {
  switch(action.type) {
    case actionTypes.FETCH_PROGRAM_INFO_SUCCESS:
      return {
        ...state,
        program: action.program,
      };

    case actionTypes.FETCH_PROGRAM_INFO_FAILURE:
      return {
        ...state,
        error: extractError(action.error),
      };

    case actionTypes.FETCH_MODULE_SUCCESS:
      return {
        ...state,
        currentModule: action.currentModule,
        isSubscribed: action.isSubscribed,
        uncompletedSections: action.uncompletedSections,
      };

    case actionTypes.SUBMIT_COMPLETE_MODULE_SECTION_SUCCESS:
      const completedSection = state.currentModule.sections.find(x => x.sort === action.sectionSort);
      const nextSection = state.currentModule.sections.find(x => x.sort === action.sectionSort + 1);

      if (nextSection) {
        return update(state, {
          currentModule: {
            sections: {
              [state.currentModule.sections.indexOf(completedSection)]: {
                isCompleted: { $set: true },
              },
              [state.currentModule.sections.indexOf(nextSection)]: {
                isOpen: { $set: true },
              },
            },
          },
          uncompletedSections: { $set: action.newUncompletedSections },
        });
      } else {
        return update(state, {
          currentModule: {
            sections: {
              [state.currentModule.sections.indexOf(completedSection)]: {
                isCompleted: { $set: true },
              },
            },
          },
          uncompletedSections: { $set: action.newUncompletedSections },
        });
      }

    case actionTypes.FETCH_PROGRAM_FUNDRAISER_SUCCESS:
      return {
        ...state,
        fundraiser: action.fundraiser,
      };

    case actionTypes.TOGGLE_SECTION_OPEN_STATUS:
      const toggledSection = state.currentModule.sections.find(x => x.sort === action.sectionSort);
      return update(state, {
        currentModule: {
          sections: { [state.currentModule.sections.indexOf(toggledSection)]: { $toggle: ['isOpen'] } },
        },
      });

    case actionTypes.ENROLL_FOR_PROGRAM_ON_MODULE_SUCCESS:
      return {
        ...state,
        isSubscribed: true,
      };
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/modules/programs/module/reducer.js